import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import Config from '../config';
import {
    Page,
    Preload,
    WKError,
} from '../components';
import '../styles/recorddetaillist/JoinLectureListPage.css';
import {
    Flex,
    FlexItem,
} from 'react-weui';
import {isLZWKAPP, judgeAPPVersion} from '../utils';
import { toLecture } from '../utils/connectApp'
import onRecordImg from '../images/no-record-data.png';

class JoinLectureListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialized: false, 
            lectures: '',
        }
        this.handleRefresh = this.handleRefresh.bind(this)

    }

    hideActionSheet() {
        this.setState({
            showCancel: false,
        });
    }

    handleRefresh() {
        window.location.reload();
    }

    componentDidMount() {
        axios.get(`/api/history/lecturer_record`,{params: {offset: this.state.nextOffset}}).then((response) => {
            const {lectures} = response.data.data
            if (response.data.code === 0) {
                this.setState({
                    lectures: lectures,
                    initialized: true,
                });
                if (lectures.length <= 0) {
                    let href = '/?st=join-lecture-list-page_404';
                    if (isLZWKAPP() && ((window.systemType === 'ios' && judgeAPPVersion(370)) || (window.systemType === 'android' && judgeAPPVersion(262)))){
                        href = 'lizhiweike://home';
                    }
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '没有讲过的课程',
                            img: onRecordImg,
                            href: href,
                            btn: '回首页看看',
                        }
                    });
                }
            }
        });
    }

    handleScrollTop(){
        document.body.scrollTop = document.documentElement.scrollTop = 0
    }

    onClickItem (item) {
        if (isLZWKAPP()) {
            toLecture({ id: item.lecture.id, lectureMode: item.lecture.lecture_mode })
        } else {
            location.assign(`/lecture/${item.lecture.id}`)
        }
    }

    render() {
        const {initialized, lectures} = this.state
        const {error} = this.props
        if (!initialized) {
            return <Preload />
        }
        if (error.showError) {
            return (
                <div className="sharecard-slide-page_error">
                    <div className="join-lecture-list-page-title"><span onClick={this.handleRefresh}>作为嘉宾参与的课程</span></div>
                    <WKError />
                </div>
            )
        }
        return (
            <Page className="join-lecture-list-page ">
                <div className="join-lecture-list-page-div">
                    <div className="join-lecture-list-page-title"><span onClick={this.handleRefresh}>作为嘉宾参与的课程</span></div>
                    <div className="join-lecture-list-page-list">
                        {
                            lectures.map((item) => {
                                const shouldLinkToAPP = isLZWKAPP() && ((window.systemType === 'ios' && judgeAPPVersion(370)) || (window.systemType === 'android' && judgeAPPVersion(262)));
                                return (
                                    <a onClick={e => this.onClickItem(item)}>
                                        <div className="join-lecture-list-page-flex">
                                            <Flex>
                                                <FlexItem className='join-lecture-list-page-item-img'>
                                                    <div className="join-lecture-list-page-img"
                                                         style={{backgroundImage: `url(${item.lecture.cover_url})`}}>
                                                    </div>
                                                </FlexItem>
                                                <FlexItem className="join-lecture-list-page-item-content" onClick={this.handleScrollTop.bind(this)}>
                                                    <ul className="join-lecture-list-page-ul">
                                                        <li className="join-lecture-list-page-li-first join-lecture-list-page-font">{item.lecture.name}</li>
                                                        <li className="join-lecture-list-page-li-second join-lecture-list-page-font">课程创建者：{item.account.nickname}</li>
                                                    </ul>
                                                </FlexItem>
                                            </Flex>
                                        </div>
                                    </a>
                                )
                            })
                        }
                    </div>
                </div>
            </Page>
        );
    }
}

export default connect((state) => ({
    error: state.error,
}))(JoinLectureListPage)



// WEBPACK FOOTER //
// ./src/pages/JoinLectureListPage.js